var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookingMeeting(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_meeting_room") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "7 0.5 7 6.5 1 6.5 1 8.5 7 8.5 7 14.5 9 14.5 9 8.5 15 8.5 15 6.5 9 6.5 9 0.5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "REVAMP-2022---White-Mobile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-Flexi-fesk-attivo",
    transform: "translate(-98.000000, -444.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_meeting_room",
    transform: "translate(98.000000, 444.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,26.5 C0,11.8644541 11.8612362,0 26.5,0 L26.5,0 C41.1355459,0 53,11.8612362 53,26.5 L53,26.5 C53,41.1355459 41.1387638,53 26.5,53 L26.5,53 C11.8644541,53 0,41.1387638 0,26.5 L0,26.5 Z",
    id: "Background",
    fill: "#A6B1FC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "groups_black_24dp-copy",
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#A6B1FC",
    cx: 19,
    cy: 14,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,27 C20.6568542,27 27.0057678,27.8235209 27.0057678,26.1666667 C27.0057678,24.5098124 20.6568542,21 19,21 C17.3431458,21 11.419754,23.6764791 11.419754,25.3333333 C11.419754,26.9901876 17.3431458,27 19,27 Z",
    id: "Oval-Copy",
    fill: "#A6B1FC"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 38,
    height: 38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33333333,20.5833333 C8.075,20.5833333 9.5,19.1583333 9.5,17.4166667 C9.5,15.675 8.075,14.25 6.33333333,14.25 C4.59166667,14.25 3.16666667,15.675 3.16666667,17.4166667 C3.16666667,19.1583333 4.59166667,20.5833333 6.33333333,20.5833333 Z M8.1225,22.325 C7.53666667,22.23 6.95083333,22.1666667 6.33333333,22.1666667 C4.76583333,22.1666667 3.2775,22.4991667 1.93166667,23.085 C0.76,23.5916667 0,24.7316667 0,26.0141667 L0,28.5 L7.125,28.5 L7.125,25.9508333 C7.125,24.6366667 7.48916667,23.4016667 8.1225,22.325 Z M31.6666667,20.5833333 C33.4083333,20.5833333 34.8333333,19.1583333 34.8333333,17.4166667 C34.8333333,15.675 33.4083333,14.25 31.6666667,14.25 C29.925,14.25 28.5,15.675 28.5,17.4166667 C28.5,19.1583333 29.925,20.5833333 31.6666667,20.5833333 Z M38,26.0141667 C38,24.7316667 37.24,23.5916667 36.0683333,23.085 C34.7225,22.4991667 33.2341667,22.1666667 31.6666667,22.1666667 C31.0491667,22.1666667 30.4633333,22.23 29.8775,22.325 C30.5108333,23.4016667 30.875,24.6366667 30.875,25.9508333 L30.875,28.5 L38,28.5 L38,26.0141667 Z M25.7133333,21.6125 C23.8608333,20.7891667 21.5808333,20.1875 19,20.1875 C16.4191667,20.1875 14.1391667,20.805 12.2866667,21.6125 C10.5766667,22.3725 9.5,24.0825 9.5,25.9508333 L9.5,28.5 L28.5,28.5 L28.5,25.9508333 C28.5,24.0825 27.4233333,22.3725 25.7133333,21.6125 Z M12.7775,25.3333333 C12.92,24.9691667 12.9833333,24.7158333 14.2183333,24.2408333 C15.7541667,23.6391667 17.3691667,23.3541667 19,23.3541667 C20.6308333,23.3541667 22.2458333,23.6391667 23.7816667,24.2408333 C25.0008333,24.7158333 25.0641667,24.9691667 25.2225,25.3333333 L12.7775,25.3333333 Z M19,12.6666667 C19.8708333,12.6666667 20.5833333,13.3791667 20.5833333,14.25 C20.5833333,15.1208333 19.8708333,15.8333333 19,15.8333333 C18.1291667,15.8333333 17.4166667,15.1208333 17.4166667,14.25 C17.4166667,13.3791667 18.1291667,12.6666667 19,12.6666667 M19,9.5 C16.3716667,9.5 14.25,11.6216667 14.25,14.25 C14.25,16.8783333 16.3716667,19 19,19 C21.6283333,19 23.75,16.8783333 23.75,14.25 C23.75,11.6216667 21.6283333,9.5 19,9.5 L19,9.5 Z",
    id: "Shape",
    fill: "#0A24EB",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#0A24EB",
    cx: 41.5,
    cy: 42.5,
    rx: 11,
    ry: 10.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-/-small-/-add-copy-4",
    transform: "translate(33.500000, 35.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingMeeting);
export default __webpack_public_path__ + "static/media/booking-meeting.5fe8ba388989f137e87f76a2500223df.svg";
export { ForwardRef as ReactComponent };